import { type PropsWithChildren } from 'react';

import { HoneycombColorMetadataContext } from '../context/honeycomb-color-metadata.context.js';
import { HoneycombTooltipMetadataContext } from '../context/honeycomb-tooltip-metadata.context.js';
import { useBuildMetadata } from '../hooks/use-build-metadata.js';
import { useHoneycombData } from '../hooks/use-honeycomb-data.js';

export const HoneycombMetadataProvider = ({ children }: PropsWithChildren) => {
  const data = useHoneycombData();
  const {
    honeycombDataWithColoringMetadata,
    honeycombDataWithTooltipMetadata,
  } = useBuildMetadata(data);

  return (
    <HoneycombColorMetadataContext.Provider
      value={{
        tileData: data,
        colorMetadata: honeycombDataWithColoringMetadata,
      }}
    >
      <HoneycombTooltipMetadataContext.Provider
        value={{
          tooltipMetadata: honeycombDataWithTooltipMetadata,
        }}
      >
        {children}
      </HoneycombTooltipMetadataContext.Provider>
    </HoneycombColorMetadataContext.Provider>
  );
};
